module.exports = __webpack_public_path__ + "img/VANM.b6d284a9.svg";